import React, { useState, useEffect, memo } from "react";
import classNames from "classnames";

import connectProps from "fantastic/lib/connectProps";
import getHovered from "fantastic/selectors/getHovered";
import getSelected from "fantastic/selectors/getSelected";

export default () => Component => {
  const SelectableComponent = props => {
    const {
      id,
      meta: { selectable = false, type, selected, edit, editable},
      show
    } = props;

    const optionClasses = (val) => {
      return classNames(
        'btn btn-form',
        { 'active': isActive(val) }
      );
    };

    const iconSizeClasses = (val) => {
      return classNames(
        {
          'fa-lg': val === 'mobile',
          'item-icon': type === "ITEM",
          'section-icon': type === "SECTION"
        }
      );
    }

    const divClasses = classNames("ftc-selectable", {
      "ftc-selectable--selected": (selected && !editable) || (selected && editable && !edit),
      "ftc-selectable--section": type === "SECTION",
      "ftc-selectable--item": type === "ITEM",
      "ftc-selectable--cell": type === "CELL",
      "ftc-selectable--desktop": show === 'desktop' && type === "ITEM",
      "ftc-selectable--mobile": show === 'mobile' && type === "ITEM",
      "ftc-selectable--desktop-section": show === 'desktop' && type === "SECTION",
      "ftc-selectable--mobile-section": show === 'mobile' && type === "SECTION",
      "ftc-selectable--divider": type === "ITEM" && props.kind === "divider"
    });

    const attrs =
      type === "CELL"
        ? {}
        : {
            "data-selectable-id": id
          };

    return selectable ? (
      <div {...attrs} className={divClasses}>
        {selected &&
          type ===
            "SECTION"[
              ((<span key="0" className="ftc-selectable__line--left" />),
              (<span key="1" className="ftc-selectable__line--right" />))
            ]}
        { show ? <span className={`fa fa-${show} ${iconSizeClasses(show)} ftc-selectable--device-icon`}> </span> : null }
        <Component {...props} />
      </div>
    ) : (
      <Component {...props} />
    );
  };

  const arePropsEqual = (prev, next) => {
    return JSON.stringify(prev) === JSON.stringify(next);
  };

  return memo(SelectableComponent, arePropsEqual);
};
